module.exports = __webpack_public_path__ + "img/pizza-with-hand-1.b5c08d74.jpg";